<template>
    <draggable
        v-bind="dragOptions"
        tag="div"
        class="border-left border-secondary"
        :force-fallback="true"
        :list="list"
        :value="value"
        :level="level"
        @input="emitter"
    >
        <div class="cursor-pointer user-select-none" v-for="el in realValue" :key="el.item.id">
            <div class="border border-secondary px-4 py-2 ml-2 mb-2">{{ el.item.name }}</div>
            <div class="pl-4">
                <NestedDraggable :level="level + 1" :list="el.children"></NestedDraggable>
            </div>
        </div>
    </draggable>
</template>

<script>
import draggable from 'vuedraggable';

// Based on https://github.com/SortableJS/Vue.Draggable/blob/017ab498428efef966d72ea2be547cb0213cd6bb/example/components/nested/nested-test.vue
export default {
    name: "NestedDraggable",

    components: {
        draggable,
    },

    props: {
        level: {
            type: Number,
            required: false,
            default: 0,
        },
        value: {
            required: false,
            type: Array,
            default: null
        },
        list: {
            required: false,
            type: Array,
            default: null
        }
    },

    methods: {
        emitter(value) {
            this.$emit("input", value);
        },
    },

    computed: {
        dragOptions() {
            return {
                animation: 100,
                group: "description",
                disabled: false,
            };
        },
        // this.value when input = v-model
        // this.list  when input != v-model
        realValue() {
            return this.value ? this.value : this.list;
        }
    },
};
</script>

<style scoped>
.sortable-ghost {
    background-color: #eeeeee;
}

.sortable-fallback {
    display: none;
}
</style>
